module.exports = __webpack_public_path__ + "img/sv.sv2b995d4.svg";